// extracted by mini-css-extract-plugin
module.exports = {"ManagerAddNewsButton":"ManagerNews_ManagerAddNewsButton__PfUkU"};